import { get } from 'services';

export interface QueryObject {
  api: string;
  params?: { [key: string]: string };
  labels: string;
  values: string;
  key?: string[];
  sort?: 'asc' | 'dsc';
  sortBy?: Array<string>;
}

interface QueryRespone {
  values: any[];
  data: any[];
  labels: any[];
}

export const FetchDataForReporting: (
  data: QueryObject
) => Promise<QueryRespone> = q => {
  return new Promise((resolve, reject) => {
    get({
      subUrl: q.api,
      params: q.params
    }).then(response => {
      let workingData: any[] = [];

      if (q.key) {
        q.key.forEach(key => {
          if (Array.isArray(response.data.data[key])) {
            workingData.push(...response.data.data[key]);
          } else {
            workingData.push(response.data.data[key]);
          }
        });
      } else {
        workingData.push(...response.data);
      }

      if (q.sortBy !== undefined) {
        const sortBy = q.sortBy;
        workingData = workingData.sort((a: any, b: any) => {
          const x = sortBy.reduce((p, c) => p + a[c], 0);
          const y = sortBy.reduce((p, c) => p + b[c], 0);
          if (q.sort === 'asc') return y - x;
          else return x - y;
        });
      } else if (q.sort === 'asc') {
        workingData = workingData.sort((a: any, b: any) => a - b);
      } else if (q.sort === 'dsc') {
        workingData = workingData.sort((a: any, b: any) => b - a);
      }

      resolve({
        data: workingData,
        values: q.values ? workingData.map(d => d[q.values]) : workingData,
        labels: workingData.map(d => d[q.labels])
      });
    });
  });
};
